// client/src/components/routing/PermissionGuard.js
import React from 'react';
import { useAuth } from '../../context/auth/AuthProvider';
import { Loader2 } from 'lucide-react';
import { hasPermission } from '../../utils/permissions'; // Importação adicionada

const PermissionGuard = ({ 
    requiredPermission, 
    requiredFeature, 
    fallback = null, 
    children 
}) => {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-64">
                <Loader2 className="animate-spin text-primary" size={32} />
            </div>
        );
    }
    
    // Usa função centralizada de permissões
    const hasRequiredPermission = requiredPermission 
        ? hasPermission(user, requiredPermission) 
        : true;
    
    // Verificação segura de features do plano
    const hasRequiredFeature = requiredFeature 
        ? user?.account?.plano?.features?.[requiredFeature] ?? false
        : true;

    if (hasRequiredPermission && hasRequiredFeature) {
        return <>{children}</>;
    }

    return fallback;
};

export default PermissionGuard;